import * as React from "react";
const SvgGrid20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 18,
        height: 16,
        fill: "black",
        viewBox: "0 0 18 16"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M0 0h18v16H0V0Zm2 2v5h6V2H2Zm8 0v5h6V2h-6Zm6 7h-6v5h6V9Zm-8 5V9H2v5h6Z",
      clipRule: "evenodd"
    })
  );
export default SvgGrid20Px;
